@if (icon) {
  <div class="main-icon m-b-4">
    @if (icon !== 'recrewt') {
      <mat-icon class="on-surface-medium m-1">{{ icon }}</mat-icon>
    }
    @if (icon === 'recrewt') {
      <img
        alt="Icon"
        class="tint-gray recrewt-icon"
        src="assets/images/RC_Logo_Icon.svg"
        />
    }
  </div>
}
<h2 class="m-b-1">{{ headline | translate }}</h2>
<p class="on-surface-medium empty-state-text m-b-3">{{ (text | translate) + dynamicText }}</p>
@if (!!buttonText.length) {
  <button
    (click)="buttonClicked.emit()"
    color="accent"
    mat-raised-button
    >
    @if (!!buttonIcon) {
      <mat-icon>{{ buttonIcon }}</mat-icon>
    }
    {{ buttonText | translate }}
  </button>
}
